import React from 'react';
import cn from 'classnames';
import { GreenDot } from 'components/core/GreenDot';
import { MainPageNavigation, ModalId } from 'src/types';
import { useTranslationsContext } from 'store/translations';
import './Navigation.styl';
import { useStoreContext } from 'store/app';

interface NavigationProps {
    items: MainPageNavigation[];
    openNavModal: Record<ModalId, boolean>;
    onOpenNavModal: (key: ModalId) => void;
    onCloseNavModal: (key: ModalId) => void;
    highLightedItem?: ModalId;
    preopenId?: string;
    onPreopenOpened?: () => void;
}

export const Navigation = ({
    items,
    openNavModal,
    onOpenNavModal,
    onCloseNavModal,
    highLightedItem,
    preopenId,
    onPreopenOpened
}: NavigationProps) => {
    const { translate } = useTranslationsContext();
    const { logOperation } = useStoreContext();

    return (
        <nav className="navigation">
            {items.map(({ id, label, iconSrc, modalId, ModalElem, isGreenDotVisible }) => (
                <React.Fragment key={modalId}>
                    <div
                        className={cn('navigation-item', {
                            ['hidden']: highLightedItem && modalId !== highLightedItem
                        })}
                        style={{ color: highLightedItem ? '#fff' : undefined }}
                        onClick={() => {
                            if (modalId) {
                                logOperation('main_page', 'click', modalId);
                                onOpenNavModal(modalId);
                            }
                        }}
                        id={id}
                    >
                        <img className="navigation-item-icon" src={iconSrc} alt="" />
                        <span>{translate(label)}</span>
                        <GreenDot
                            className="navigation-item-dot"
                            isVisible={modalId !== ModalId.Draw && (isGreenDotVisible?.() || !!highLightedItem)}
                        />
                    </div>

                    {modalId && ModalElem && openNavModal[modalId] && (
                        <ModalElem
                            isOpened
                            onClose={() => onCloseNavModal(modalId)}
                            preopenId={preopenId}
                            onPreopenOpened={onPreopenOpened}
                        />
                    )}
                </React.Fragment>
            ))}
        </nav>
    );
};
